import { Controller } from "@hotwired/stimulus"
import "exif-js"

export default class extends Controller {
  static targets = ["image", "rotationInput", "previewImage"]
  static values = { 
    currentRotation: Number,
    exifOrientation: Number
  }

  connect() {
    this.currentRotationValue = this.currentRotationValue || 0
    this.updateImageRotation()
  }

  rotateLeft() {
    this.currentRotationValue = (this.currentRotationValue - 90 + 360) % 360
    this.updateImageRotation()
    this.updateHiddenInput()
  }

  rotateRight() {
    this.currentRotationValue = (this.currentRotationValue + 90) % 360
    this.updateImageRotation()
    this.updateHiddenInput()
  }

  resetRotation() {
    this.currentRotationValue = 0
    this.updateImageRotation()
    this.updateHiddenInput()
  }

  handleFileUpload(event) {
    const file = event.target.files[0]
    if (!file) return

    window.EXIF.getData(file, () => {
      const orientation = window.EXIF.getTag(file, "Orientation") || 1
      this.exifOrientationValue = orientation
      this.applyExifOrientation(orientation)
    })

    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.src = e.target.result
        this.previewImageTarget.style.display = 'block'
      }
    }
    reader.readAsDataURL(file)
  }

  applyExifOrientation(orientation) {
    let rotation = 0
    
    switch (orientation) {
      case 3:
        rotation = 180
        break
      case 6:
        rotation = 90
        break
      case 8:
        rotation = 270
        break
      case 2:
      case 4:
      case 5:
      case 7:
        break
      default:
        rotation = 0
    }

    this.currentRotationValue = rotation
    this.updateImageRotation()
    this.updateHiddenInput()
  }

  updateImageRotation() {
    const transform = `rotate(${this.currentRotationValue}deg)`
    
    if (this.hasImageTarget) {
      this.imageTarget.style.transform = transform
    }
    
    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.style.transform = transform
    }
  }

  updateHiddenInput() {
    if (this.hasRotationInputTarget) {
      this.rotationInputTarget.value = this.currentRotationValue
    }
  }
}
